import Vue from 'vue'

// import ES6 style
import {VueMasonryPlugin} from 'vue-masonry';

Vue.use(VueMasonryPlugin)